import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { BrowserRouter } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const publishableKey = (process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '').trim();
// Dev: log which Clerk instance (key encodes instance URL; helps catch stale .env)
if (publishableKey && process.env.NODE_ENV === 'development') {
  try {
    const b64 = publishableKey.replace(/^pk_(test|live)_/, '');
    const decoded = typeof atob !== 'undefined' ? atob(b64) : '';
    if (decoded) console.log('[Clerk] Instance:', decoded.replace(/\$$/, ''));
  } catch (_) {}
}

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));

const appContent = !publishableKey ? (
  <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif', maxWidth: '480px', margin: '0 auto' }}>
    <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>Missing Clerk key</h1>
    <p style={{ color: '#666' }}>
      Set <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> in <code>frontend/.env</code> (dev) or pass it when building the Docker image for production (e.g. <code>--build-arg REACT_APP_CLERK_PUBLISHABLE_KEY=pk_...</code>).
    </p>
  </div>
) : (
  <ClerkProvider publishableKey={publishableKey}>
    <BrowserRouter>
      {stripePromise ? (
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      ) : (
        <App />
      )}
    </BrowserRouter>
  </ClerkProvider>
);

root.render(
  <React.StrictMode>
    {appContent}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA (network-first so F5 always gets latest app)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      return Promise.all(registrations.map((r) => r.unregister()));
    }).then(() => {
      return navigator.serviceWorker.register('/service-worker.js');
    })
      .then((registration) => {
        console.log('SW registered: ', registration);
        setInterval(() => registration.update(), 60 * 60 * 1000);
      })
      .catch((err) => {
        console.log('SW registration failed: ', err);
      });
  });
}
